export default function CExercises() {
  return <h2>C Exercises</h2>;
}
